

<div class="modal-signup modal-content" *ngIf="ShowList">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

    <div class="card-header wh-header border-bottom">
      Add Notes
      <button type="button" class="close" data-dismiss="modal"
              (click)="activeModal.dismiss('Cross click')"
              aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form class="form" (ngSubmit)="onSubmit()">
      <div class="modal-body overflow-x padding-top-0px">

        <section id="form-action-layouts">


          <div class="row justify-content-md-center">
            <div class="col-md-12 padding-left-0px">
              <div class="card margin-left-0px margin-right-0px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                  
                  <div class="px-6">



                    <div class="form-body">
                      

                      <div class="row">
                        <div class="form-group offset-md-1 col-md-10 col-xs-10 margin-bottom-5px padding-left-30px padding-top-20px">
                          <div class="row">
                                                      

                              <textarea class="borderall form-control" rows="6" cols="50" [(ngModel)]="notesText" name="notesText"> </textarea>
                                                       

                          </div>

                        </div>
                      </div>
                    </div>










                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="ModalClose()">Back</button>
        <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>

      </div>

    </form>
  </div>
</div>




